var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{attrs:{"id":"Paragraph"}},[_c('h2',[_vm._v(_vm._s(_vm.subtitle))]),_c('p',{staticClass:"letter-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }